// extracted by mini-css-extract-plugin
export default {"shadowed":"AboutMe_shadowed__vCVUs","hand":"AboutMe_hand__n11Sg","wave":"AboutMe_wave__NBnt0"};